import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSessionJWT, useSessionCtx } from "utils";
import { verifyEmailVerificationCode } from "./index.js";

export default function useVerifyEmailVerificationCode() {
  const queryClient = useQueryClient();
  const { sessionJWT } = useSessionJWT();
  const { sessionId } = useSessionCtx();
  const ctx = {
    ...sessionJWT,
    sessionId,
  };

  return useMutation({
    mutationFn: ({ code, nonce }) => verifyEmailVerificationCode(ctx, code, nonce),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["email-verification"] });
    },
  });
}
